import { t } from "i18next";

import {
  type Building,
  CURRENT_USER_LOCATION_ID,
  CustomFields,
  FIND_MY_CAR_LOCATION_ID,
  Poi,
  Position,
} from "@/libs/models";
import type { SliceProps } from "../find_my_car/types";

export const mapFindMyCarToPosition = (
  findMyCar: SliceProps,
  building?: Building | null,
) => {
  const cartesianCoordinate = building?.coordinateConverter.toCartesian({
    lat: findMyCar?.coordinates?.lat || 0,
    lng: findMyCar?.coordinates?.lng || 0,
  });

  return new Position(
    building?.id ?? 0,
    findMyCar.floorId ?? 0,
    findMyCar.coordinates?.lat ?? 0,
    findMyCar.coordinates?.lng ?? 0,
    cartesianCoordinate?.x,
    cartesianCoordinate?.y,
  );
};

export const mapFindMyCarToPOI = (
  findMyCar: SliceProps,
  building?: Building | null,
) => {
  return new Poi(
    FIND_MY_CAR_LOCATION_ID, //id
    t("find_my_car.name"), //name
    mapFindMyCarToPosition(findMyCar, building),
    CURRENT_USER_LOCATION_ID, //category
    [], // categories
    "", //info
    building?.id ?? 0, //buildingId
    new CustomFields([]),
    "/images/car.svg",
  );
};
